/* eslint-disable max-len */
import React, {
  useCallback, useEffect, useState, useMemo,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';

import modbusMapsActions from '@state/modbusMaps/actions';
import devicesApi from '@api/devicesApi';

function useDispositivos() {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const abortC = new AbortController();
  const { signal } = abortC;

  const [form] = Form.useForm();

  const createEditValues = useSelector(({ modbusMaps: a }) => a.createEditValues);
  const isEditDefault = useSelector(({ modbusMaps: a }) => a.isEditDefault);

  // const [loadingDevicesTypeToEdit, setLoadingDevicesTypeToEdit] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  const [openModalVar, setOpenModalVar] = useState(false);

  const [dataFormModal, setDataFormModal] = useState({
    index: null,
    variable_name: '',
    variable_key: '',
    variable_descriptor: 'v={VF1}\\nx=v[1]',
    modbus_name: '',
    modbus_function: '',
    modbus_direction: '',
    factor_to_multiply: '',
    datatypes: '',
  });

  const currentUserRol = useSelector(({ user }) => user.role);
  const [businessData, setBusinessData] = useState([]);

  // Reemplazar el de arriba por este al hacer las integraciones
  const initialForm = useMemo(() => ({
    device_type_name: '',
    device_type_description: '',
    maps: [],
    variables: [],
    variableMap: [],
  }), []);

  const onFinish = useCallback(async (values) => { // submit: create device or edit device

    // Verificar que al menos haya una Variable
    if (!createEditValues?.variableMap || createEditValues?.variableMap.length === 0) {

      message.error(t('views.dynamic_device_types_create_edit.feedbacks.add_at_least_one_var'));
      return false;

    }

    setSaveLoading(true);

    if (!isEditDefault) { //  create device

      let devices_type = {};
      const modbus_map = {};

      let fields = {};
      setSaveLoading(true);

      // Organizo el Modbus maps
      Object.entries(createEditValues?.variableMap).forEach(([key, value]) => {

        const data_value = {
          name: value.modbus_name,
          addres: Number(value.modbus_direction),
          factor: parseFloat(value.factor_to_multiply),
          size: Number(value.modbus_size),
          data_type: value.datatypes,
          function: Number(value.modbus_function),
        };
        modbus_map[value.modbus_name] = data_value;

      });

      fields = createEditValues?.variableMap.map((obj, key) => {

        const item = {
          name: obj.variable_name,
          edge_name: obj.variable_key,
          database_name: obj.variable_key,
          //  eslint-disable-next-line
          modbus_map: { fields: [obj.modbus_name] },
          descriptor: obj.variable_descriptor,

          device_type: '',
          unit_type: '',
          format: '',
          msgT: 'c',
          field_tag_id: [],
        };
        return item;

      });

      devices_type = {
        name: createEditValues.device_type_name,
        description: createEditValues.device_type_description,
        modbus_map,
        fields,
        busines_id: createEditValues?.business_type_id,
      };

      await devicesApi.createDeviceTypeUnified({ signal, body: devices_type })
        .then(async (response) => {

          message.success(t('views.dynamic_device_types_create_edit.feedbacks.save_edit_create_success'));
          dispatch(modbusMapsActions.setCreateEditValues(initialForm));
          dispatch(modbusMapsActions.setDeviceTypeIdEdit(null));

          history.push('/dispositivos/tipo-dispositivo');

        }).catch((resError) => {

          message.error(resError?.data?.detail || t('views.dynamic_device_types_create_edit.feedbacks.save_edit_create_error'));
          //  eslint-disable-next-line
          console.log(' resError ',resError); 
          setSaveLoading(false);

        });

    } else { // Edit Device

      let devices_type = {};
      const modbus_map = {};

      let fields = {};

      // Organizo el Modbus maps
      Object.entries(createEditValues?.variableMap).forEach(([key, value]) => {

        const data_value = {
          name: value.modbus_name,
          addres: Number(value.modbus_direction),
          factor: parseFloat(value.factor_to_multiply),
          size: Number(value.modbus_size),
          data_type: value.datatypes,
          function: Number(value.modbus_function),
        };
        modbus_map[value.modbus_name] = data_value;

      });

      fields = createEditValues?.variableMap.map((obj, key) => {

        const item = {
          id: obj?.id || null,
          name: obj.variable_name,
          edge_name: obj.variable_key,
          database_name: obj.variable_key,
          modbus_map: { fields: [obj.modbus_name] },
          descriptor: obj.variable_descriptor,

          device_type: isEditDefault,
          unit_type: '',
          format: '',
          msgT: 'c',
          field_tag_id: [],
        };
        return item;

      });

      devices_type = {
        name: createEditValues.device_type_name,
        description: createEditValues.device_type_description,
        modbus_map,
        fields,
      };

      devicesApi.editDeviceTypeUnified({ signal, body: devices_type, id: isEditDefault })
        .then(async (response) => {

          // actualizado el device_twin
          const devicesType = {
            device_types: [
              response.id,
            ],
          };

          try {

            await devicesApi.deviceTwin({ signal, body: devicesType });

          } catch (error) {

            console.log('error deviceTwin ', error);

          }

          message.success(t('views.dynamic_device_types_create_edit.feedbacks.save_edit_create_success'));
          dispatch(modbusMapsActions.setCreateEditValues(initialForm));
          dispatch(modbusMapsActions.setDeviceTypeIdEdit(null));

          history.push('/dispositivos/tipo-dispositivo');

        })
        .catch((resError) => {

          message.error(resError?.data?.detail || t('views.dynamic_device_types_create_edit.feedbacks.save_edit_create_error'));
          //  eslint-disable-next-line
          console.log(' resError ',resError); 
          setSaveLoading(false);

        });

    }

    return true;
    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo.errorFields[0].errors[0]);
    message.error(errorInfo.errorFields[0].errors[0]);

  };

  const formOnValuesChange = useCallback( // handle data
    (changedValues) => {

      const newEditValues = { ...createEditValues };

      Object.entries(changedValues).forEach(([key, value]) => {

        newEditValues[key] = value;

      });

      dispatch(modbusMapsActions.setCreateEditValues(newEditValues));

    },
    // eslint-disable-next-line
    [createEditValues,dispatch]
  );

  // funciones migradas por mi
  const cancelCreateEditDeviceType = useCallback(
    () => {

      history.replace('/dispositivos/tipo-dispositivo');

    },
    // eslint-disable-next-line
    [],

  );

  // Listado de variable
  const getValFun = (id) => {

    let valueString = '';

    switch (id) {

      case '1':
        valueString = 'Read coils or digital outputs';
        break;
      case '2':
        valueString = 'Read digital inputs';
        break;
      case '3':
        valueString = 'Read registers or analog outputs';
        break;
      case '4':
        valueString = 'Read analog inputs';
        break;
      case '5':
        valueString = 'Write single coil or output';
        break;
      case '6':
        valueString = 'Write single register';
        break;
      case '15':
        valueString = 'Write multiple coils or outputs';
        break;
      case '16':
        valueString = 'Write multiple registers';
        break;
      default:
        valueString = id;
        break;

    }

    return valueString;

  };

  const delVariableRow = (row) => {

    const newEditValues = { ...createEditValues };

    const { variableMap } = newEditValues;

    variableMap.splice(row.index, 1);

    newEditValues.variableMap = variableMap;

    console.log(newEditValues);

    dispatch(modbusMapsActions.setCreateEditValues(newEditValues));

  };

  const editVariableRow = (row) => {

    setDataFormModal(row);
    setOpenModalVar(true);

  };

  const columns = [
    {
      title: t('views.dynamic_device_types_create_edit.labels.device_type_name_g'),
      dataIndex: 'variable_name',
      key: 'variable_name',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.variable_key_g'),
      dataIndex: 'variable_key',
      key: 'variable_key',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.variable_descriptor_g'),
      dataIndex: 'variable_descriptor',
      key: 'variable_descriptor',
    },
    /* {
      title: t('views.dynamic_device_types_create_edit.labels.modbus_name_g'),
      dataIndex: 'modbus_name',
      key: 'modbus_name',
    }, */
    {
      title: t('views.dynamic_device_types_create_edit.labels.modbus_function_g'),
      dataIndex: 'modbus_function',
      key: 'modbus_function',
      render: (modbus_function) => getValFun(modbus_function) || '',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.modbus_direction_g'),
      dataIndex: 'modbus_direction',
      key: 'modbus_direction',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.factor_to_multiply_g'),
      dataIndex: 'factor_to_multiply',
      key: 'factor_to_multiply',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.modbus_size'),
      dataIndex: 'modbus_size',
      key: 'modbus_size',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.datatypes_g'),
      dataIndex: 'datatypes',
      key: 'datatypes',
    },
    {
      title: '',
      key: 'accion_edit',
      render: (_, record) => <FontAwesomeIcon icon={faEdit} onClick={() => editVariableRow(record)} />,
    },
    {
      title: '',
      key: 'accion_del',
      render: (_, record) => <FontAwesomeIcon icon={faTrash} onClick={() => delVariableRow(record)} />,
    },
  ];

  const getData = (objState) => {

    let data = [];
    setLoading(true);

    if (objState?.variableMap?.length > 0) {

      data = [...objState?.variableMap];

    } else {

      data = [];

    }

    setLoading(false);
    setDataSource(data);

  };

  const createVarModal = () => {

    const dataForm = {
      index: null,
      variable_name: '',
      variable_key: '',
      variable_descriptor: 'v={VF1}\\nx=v[1]',
      modbus_name: '',
      modbus_function: '',
      modbus_direction: '',
      factor_to_multiply: '',
      datatypes: '',
    };

    setDataFormModal(dataForm);
    setOpenModalVar(true);

  };

  const changeVar = (id, value) => {

    const auxDataFormModal = { ...dataFormModal };

    if (id === 'variable_name') {

      const newKeyArr = value.split(' ');
      let newKey = '';

      newKeyArr.forEach((auxKry) => {

          if (auxKry !== '') {

              newKey += auxKry.substring(0, 3);

}

});

      auxDataFormModal.variable_key = newKey;
      auxDataFormModal.modbus_name = newKey;

      auxDataFormModal.variable_descriptor = `v={${newKey}}\\nx=v[1]`;

  } else if (id === 'variable_key') {

      auxDataFormModal.modbus_name = value;
      auxDataFormModal.variable_descriptor = `v={${value}}\\nx=v[1]`;

}

    auxDataFormModal[id] = value;
    setDataFormModal(auxDataFormModal);

  };

  const createEditModalSave = () => {

    // Verificar que las Propiedades este completas
    let isValidAllDatVar = true;
    Object.keys(dataFormModal).forEach((indice) => {

      if (indice !== 'index') {

        if (dataFormModal[indice] === '' || dataFormModal[indice] === null) {

          isValidAllDatVar = false;

        }

      }

    });

    if (!isValidAllDatVar) {

      message.error(t('views.dynamic_device_types_create_edit.feedbacks.completed_var'));
      return false;

    }

    let variableMap = [];
    let init = 0;
    const newEditValues = { ...createEditValues };

    // validar que la variable no se repita
    let isValidAllDatVarExists = true;
    if (newEditValues?.variableMap) {

      newEditValues.variableMap.forEach((auxNewEditValue) => {

        if (dataFormModal.index !== '' && dataFormModal.index !== null) { // Existe

          if (auxNewEditValue.variable_key === dataFormModal.variable_key && auxNewEditValue.index !== dataFormModal.index) {

            isValidAllDatVarExists = false;

          }

        } else { // Nuevo

           // eslint-disable-next-line
          if (auxNewEditValue.variable_key === dataFormModal.variable_key) {

            isValidAllDatVarExists = false;

          }

        }

      });

    }

    if (!isValidAllDatVarExists) {

      message.error(t('views.dynamic_device_types_create_edit.feedbacks.valid_var_exists'));
      return false;

}

    if (newEditValues.variableMap == null) {

      newEditValues.variableMap = [];

    }

    if (dataFormModal.index !== '' && dataFormModal.index !== null) {

      variableMap = newEditValues.variableMap.map((item, index) => {

        if (dataFormModal.index === item.index) {

          return { ...dataFormModal };

        }
        return { ...item };

      });

    } else {

      variableMap = newEditValues.variableMap.map((item, index) => {

        init += 1;
        return {
          ...item,
          index,
        };

      });

      variableMap.push({ ...dataFormModal, index: init });

    }

    console.log('dataFormModal ', dataFormModal);
    console.log('createEditModalSave ', newEditValues);

    newEditValues.variableMap = variableMap;
    dispatch(modbusMapsActions.setCreateEditValues(newEditValues));

    const dataForm = {
      index: null,
      variable_name: '',
      variable_key: '',
      variable_descriptor: 'v={VF1}\\nx=v[1]',
      modbus_name: '',
      modbus_function: '',
      modbus_direction: '',
      factor_to_multiply: '',
      datatypes: '',
    };

    setDataFormModal(dataForm);
    setOpenModalVar(false);

    return true;

  };

  const readBusinessType = useCallback(async () => {

    const skip = 0;
    const limit = 1000;

    await devicesApi.getAllBusinessType({ signal, skip, limit })
      .then(async (business) => {

          const newBusiness = await Promise.all(business.map(async (obj) => {

            const item = {
              value: obj.id,
              label: obj.name,
              devices: obj.total_general,
              clients: obj.total_general_clients,
              type: obj.type,
            };
            return item;

}));

          setBusinessData(newBusiness);

      }).catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          console.log('fem ', fem);

      });

  });

  // End listado de variable
  useEffect(() => { // mount component

    if (!isEditDefault && location.pathname === '/dispositivos/tipo-dispositivo/editar-tipo-dispositivo') {

          // If trying to edit without isEditDefault, redirect to tipo-negocio
          dispatch(modbusMapsActions.setDeviceTypeIdEdit(null));
          dispatch(modbusMapsActions.setCreateEditValues(initialForm));
          history.push('/dispositivos/tipo-dispositivo');

    } else if (!isEditDefault && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin') {

        dispatch(modbusMapsActions.setDeviceTypeIdEdit(null));
        dispatch(modbusMapsActions.setCreateEditValues(initialForm));

      // If trying to create without isEditDefault and not Superadmin or Admin, redirect to tipo-negocio
          history.push('/dispositivos/tipo-dispositivo');

}

    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    readBusinessType();

  }, []);

  useEffect(() => {

    getData(createEditValues);

  }, [createEditValues, dispatch]);

  return {
    form,
    formOnValuesChange,
    onFinish,
    onFinishFailed,
    createEditValues,
    isEditDefault,
    cancelCreateEditDeviceType,
    loading,
    columns,
    dataSource,
    openModalVar,
    setOpenModalVar,
    createVarModal,
    dataFormModal,
    changeVar,
    createEditModalSave,
    saveLoading,
    businessData,
  };

}

export default useDispositivos;
